import { ChangeEvent, useState } from 'react';
import { styled } from '@stitches/configed';
import Layout from './Layout';
// import { Result } from '../Common/Result';
import CheckCircleIcon from '../Common/Icons/CheckCirleIcon';
import { Button, Form, Input, Radio } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';

const Title = styled('h4', {
  uTextSize: 'lg',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: 24,
});

const RowCheck = styled('div', {
  display: 'flex',
  alignItems: 'center',
  uGap: 4,
  svg: {
    color: '#D9DCE1',
  },
  variants: {
    passed: {
      true: {
        svg: {
          color: '#17AFA7',
        },
      },
    },
  },
});

type Props = {
  onFinish: (values: any) => Promise<{
    success?: boolean;
    errors?: { field: string; errors: string[] }[];
  }>;
};
export default function Register({ onFinish }: Props) {
  // const navigate = useNavigate();

  const [form] = Form.useForm();
  const [isSubmiting, setIsSubmiting] = useState(false);

  // const [showResult, setShowResult] = useState(false);
  const [isSixChar, setIsSixChar] = useState(false);
  const [isHasUppercase, setIsHasUppercase] = useState(false);
  const [isHasNumber, setIsHasNumber] = useState(false);
  const [isHasSpecialChar, setIsHasSpecicalChar] = useState(false);

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const password = e.target.value;
    if (password.length >= 6) {
      setIsSixChar(true);
    } else {
      setIsSixChar(false);
    }
    if (/[A-Z]/.test(password)) {
      setIsHasUppercase(true);
    } else {
      setIsHasUppercase(false);
    }
    /[0-9]/.test(password) ? setIsHasNumber(true) : setIsHasNumber(false);
    /[!@#$%^&*(),.?":{}|<>]/.test(password)
      ? setIsHasSpecicalChar(true)
      : setIsHasSpecicalChar(false);
  };

  // if (showResult) {
  //   return (
  //     <Layout>
  //       <Result
  //         type="success"
  //         title="Đăng ký thành công."
  //         message="Từ bây giờ bạn sẽ có thể email và mật khẩu để đăng nhập hệ thống."
  //       >
  //         <Button type="primary" onClick={() => navigate('/login')}>
  //           Đăng nhập tài khoản
  //         </Button>
  //       </Result>
  //     </Layout>
  //   );
  // }
  return (
    <Layout
      // fixedHeight={showResult ? true : false}
      fixedHeight={false}
      rightStyles={{ width: 560 }}
      boxStyles={{ padding: 30 }}
    >
      {/* {showResult ? (
        <Result
          type="success"
          title="Đăng ký thành công"
          message="1 email kích hoạt đã được gửi vào hòm thư Email của bạn. Bạn vui lòng kích hoạt tài khoản bằng đường link trong email để sử dụng đầy đủ tính năng trên YouGo."
        >
          <Button type="primary" onClick={() => navigate('/')}>
            Tiếp tục
          </Button>
        </Result>
      ) : ( */}
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={async (value) => {
          setIsSubmiting(true);
          const res = await onFinish(value);
          // if (res.success) {
          //   setShowResult(true);
          // }
          if (res.errors) {
            const arr = res.errors.map((x) => {
              return {
                name: x.field,
                errors: x.errors,
              };
            });
            form.setFields(arr);
            form.scrollToField(arr[0].name);
          }
          setIsSubmiting(false);
        }}
        // validateTrigger="onSubmit"
      >
        <Title>Đăng ký tài khoản Merchant</Title>
        <Form.Item name="fullname" label="Họ và tên" required>
          <Input placeholder="Nhập họ và tên" />
        </Form.Item>
        <Form.Item name="phoneNumber" label="Số điện thoại" required>
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>
        <Form.Item name="gender" label="Giới tính" required initialValue={1}>
          <Radio.Group>
            <Radio value={1}>Nam</Radio>
            <Radio value={0}>Nữ</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          required
          // rules={[{ type: 'email' }]}
        >
          <Input placeholder="Nhập số email" />
        </Form.Item>
        <Form.Item
          label="Mật khẩu"
          name="password"
          required
          // rules={[
          //   { required: true, message: 'Vui lòng nhập mật khẩu!' },
          //   {
          //     min: 6,
          //     message: 'Vui lòng nhập ít nhất 6 ký tự!',
          //   },
          // ]}
        >
          <Input.Password
            placeholder="Nhập mật khẩu mới"
            // type={showPass ? 'text' : 'password'}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            onChange={handlePasswordChange}
          />
        </Form.Item>
        <Form.Item
          label="Nhập lại mật khẩu"
          name="passwordConfirmation"
          dependencies={['password']}
          required
          rules={[
            // { required: true, message: 'Vui lòng nhập mật khẩu!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('Hai mật khẩu mà bạn đã nhập không khớp!'),
                );
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Nhập mật lại khẩu mới"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            // type={showPass ? 'text' : 'password'}
          />
        </Form.Item>
        <Form.Item label={<div></div>} colon={false}>
          Mật khẩu có độ bảo mật cao, nên có:
          <RowCheck passed={isSixChar}>
            <CheckCircleIcon />
            <span>Ít nhất 6 kí tự</span>
          </RowCheck>
          <RowCheck passed={isHasUppercase}>
            <CheckCircleIcon />
            <span>Có ký tự viết hoa (từ A - Z)</span>
          </RowCheck>
          <RowCheck passed={isHasNumber}>
            <CheckCircleIcon />
            <span>Có ký tự số (từ 0 - 9)</span>
          </RowCheck>
          <RowCheck passed={isHasSpecialChar}>
            <CheckCircleIcon />
            <span>Có ký tự đặt biệt (? * @...)</span>
          </RowCheck>
        </Form.Item>
        <Form.Item noStyle>
          <div style={{ textAlign: 'center' }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              style={{ maxWidth: 375 }}
              loading={isSubmiting}
            >
              Đăng ký
            </Button>
          </div>
        </Form.Item>
      </Form>
      {/* )} */}
    </Layout>
  );
}
